<template>
  <div class="container">
    <img src="@img/title.png" class="title" />
    <img src="@img/logo.png" class="kpfs-logo" />
    <img src="@img/btn-start.png" class="btn start" @click="$router.push('/game')" />
    <img src="@img/btn-intro.png" class="btn intro" @click="$router.push('/intro')" />

    <transition
      mode="out-in"
      enter-active-class="fadeIn animated faster"
      leave-active-class="fadeOut animated faster"
    >
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'home',
};
</script>

<style lang="scss" scoped>
.title {
  position: absolute;
  @include w(679);
  @include t(139);
  @include center(679);
}

.btn.start {
  position: absolute;
  @include w(245);
  @include t(594);
  @include l(256);
}
.btn.intro {
  position: absolute;
  @include w(245);
  @include t(721);
  @include l(256);
}
</style>
